import './styles/main.scss'
import App from './scripts/App'
import React from 'react'
import ReactDOM from 'react-dom'

const userApp = document.querySelector("#gdv-mail-form");
if (userApp)
	ReactDOM.render(<App {...userApp.dataset} />, userApp)
